export var DateRangeEnum;
(function (DateRangeEnum) {
    DateRangeEnum["LAST_WEEK"] = "LAST_WEEK";
    DateRangeEnum["LAST_MONTH"] = "LAST_MONTH";
    DateRangeEnum["CUSTOM_RANGE"] = "CUSTOM_RANGE";
})(DateRangeEnum || (DateRangeEnum = {}));
